import React from 'react';
import { connect } from 'react-redux';

import { useParams } from "react-router-dom";

import { enterAdministrationMode, leaveAdministrationMode } from 'store/common/commonActions';
import AdministrationPage from './AdministrationPage';

import localStorageHelper from 'utils/localStorageHelper';


const AdministrationPageContainer = ({ autoriseTout, autoriseConditionsSAV, enterAdministrationMode, leaveAdministrationMode }) => {

    let params = useParams();

    React.useEffect(() => {
        enterAdministrationMode();
        return () => {
            leaveAdministrationMode();
        };
    }, [enterAdministrationMode, leaveAdministrationMode])


    return (
        <AdministrationPage params={params} autoriseTout={autoriseTout} autoriseConditionsSAV={autoriseConditionsSAV} />
    );
};

const mapStateToProps = (state, ownProps) => {

    const isAdmin = localStorageHelper.isAdmin();

    const utilisateurQualiteFournisseur = localStorageHelper.getUtilisateurQualiteFournisseur();


    return {
        autoriseTout: isAdmin,
        autoriseConditionsSAV: isAdmin || utilisateurQualiteFournisseur
    };
};

const mapDispatchToProps = {
    enterAdministrationMode,
    leaveAdministrationMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationPageContainer);